import { useMemo } from "react";

import { useAxios } from "@/lib/hooks";

import {
  addAssistantAgents,
  createAssistant,
  deleteAssistant,
  getAssistant,
  getAssistants,
  removeAssistantAgents,
  updateAssistant,
} from "./assistant";
import {
  AssistantAgentsInput,
  CreateAssistantInput,
  UpdateAssistantInput,
} from "./types";

export const ASSISTANTS_QUERY_KEY = ["assistants"];

export const useAssistantApi = () => {
  const { axiosInstance } = useAxios();

  return useMemo(
    () => ({
      getAssistants: async () => getAssistants(axiosInstance),
      getAssistant: async (assistantId: string) =>
        getAssistant(assistantId, axiosInstance),
      createAssistant: async (assistant: CreateAssistantInput) =>
        createAssistant(assistant, axiosInstance),
      updateAssistant: async (
        assistantId: string,
        assistant: UpdateAssistantInput,
      ) => updateAssistant(assistantId, assistant, axiosInstance),
      deleteAssistant: async (assistantId: string) =>
        deleteAssistant(assistantId, axiosInstance),
      addAssistantAgents: async (
        assistantId: string,
        data: AssistantAgentsInput,
      ) => addAssistantAgents(assistantId, data, axiosInstance),
      removeAssistantAgents: async (
        assistantId: string,
        data: AssistantAgentsInput,
      ) => removeAssistantAgents(assistantId, data, axiosInstance),
    }),
    [axiosInstance],
  );
};
